import { render, staticRenderFns } from "./ibc_examroom_info.vue?vue&type=template&id=f8d7d086&"
import script from "./ibc_examroom_info.vue?vue&type=script&lang=js&"
export * from "./ibc_examroom_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports